"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showLink = showLink;
exports.default = void 0;

function showLink(auth, showAuth) {
  if (!auth || !showAuth) {
    return false;
  }

  if (!auth.isAuthenticated) {
    return showAuth[0];
  } else {
    return showAuth[1];
  }
}

;
var _default = showLink;
exports.default = _default;
//# sourceMappingURL=ShowLinks.js.map